import { Box, Modal, Text } from '@nimbus-ds/components';
import { InteractiveList } from '@nimbus-ds/patterns';
import { CancelAndConfirmButtons, Stack } from 'commons/components';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';

interface SelectTransferOrDeleteModalProps {
  locationName: string;
  isConfirmDisabled: boolean;
  onConfirm: () => void;
  onSelectOption: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClose: () => void;
}

function SelectTransferOrDeleteModal({
  locationName,
  isConfirmDisabled,
  onConfirm,
  onSelectOption,
  onClose,
}: Readonly<SelectTransferOrDeleteModalProps>) {
  const t = useTranslationShipping();

  return (
    <>
      <Modal.Header
        title={t('locations.deleteSteps.selectTransferOrDelete.title', {
          name: locationName,
        })}
      />
      <Modal.Body padding="none">
        <Box display="flex" flexDirection="column" gap="3">
          <Text>
            {t('locations.deleteSteps.selectTransferOrDelete.description', {
              name: locationName,
            })}
          </Text>
          <div style={{ marginLeft: '-16px', marginRight: '-16px' }}>
            <InteractiveList onChange={onSelectOption}>
              <InteractiveList.RadioItem
                description={t(
                  'locations.deleteSteps.selectTransferOrDelete.transfer.description',
                  {
                    name: locationName,
                  },
                )}
                radio={{
                  name: 'trasnfer-or-delete-selection',
                  value: 'transfer',
                }}
                title={t(
                  'locations.deleteSteps.selectTransferOrDelete.transfer.title',
                )}
              />
              <InteractiveList.RadioItem
                description={t(
                  'locations.deleteSteps.selectTransferOrDelete.delete.description',
                )}
                radio={{
                  name: 'trasnfer-or-delete-selection',
                  value: 'delete',
                }}
                title={t(
                  'locations.deleteSteps.selectTransferOrDelete.delete.title',
                )}
              />
            </InteractiveList>
          </div>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Stack spacing="base" justify="flex-end">
          <CancelAndConfirmButtons
            appearance="primary"
            onCancel={onClose}
            onConfirm={onConfirm}
            confirmText={t(
              'locations.deleteSteps.selectTransferOrDelete.confirm',
            )}
            isConfirmDisabled={isConfirmDisabled}
          />
        </Stack>
      </Modal.Footer>
    </>
  );
}

export default SelectTransferOrDeleteModal;
